import { Link } from "react-router-dom";
import talentLogo2 from "../assets/talentlogo2.png";
import usePageMeta from "../hooks/usePageMeta";

export default function NotFound() {
  usePageMeta("Not Found");

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-6">
      <div className="w-full max-w-md rounded-2xl bg-white shadow-sm border border-gray-200 p-8 text-center">
        <img
          src={talentLogo2}
          alt="Talent"
          className="h-12 w-auto mx-auto mb-6"
        />
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">Not Found</h1>
        <p className="text-sm text-gray-600 mb-6">
          The page you are trying to access is not available.
        </p>
        <Link
          to="/checkin"
          className="inline-flex items-center justify-center rounded-md bg-gray-900 px-4 py-2 text-sm font-medium text-white hover:bg-black transition-colors"
        >
          Back to Check In
        </Link>
      </div>
    </div>
  );
}
